// extracted by mini-css-extract-plugin
module.exports = {"badge":"style_badge__jhL13"};